import defaultAttributes from '../defaultAttributes';

const SignalMedium = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M2 20h.01' }],
    ['path', { d: 'M7 20v-4' }],
    ['path', { d: 'M12 20v-8' }],
  ],
];

export default SignalMedium;
